/**
 * routes.ts — fuente de verdad de las rutas de la app.
 *
 * Espejo del bloque `Routes` de docs/CONTRACTS.md §1. Cualquier cambio aquí
 * exige actualizar CONTRACTS.md (y viceversa). Subagentes paralelos importan
 * SIEMPRE desde aquí; nunca hardcodean strings de path.
 */

export const Routes = {
  // Públicas
  home: '/',
  therapies: '/terapias',
  therapyDetail: (slug: string) => `/terapias/${slug}`,
  shop: '/tienda',
  productDetail: (slug: string) => `/tienda/${slug}`,
  customOrder: '/tienda/encargo',
  gallery: '/galeria',
  galleryItem: (slug: string) => `/galeria#${slug}`,
  about: '/sobre-mi',
  events: '/eventos',
  eventDetail: (slug: string) => `/eventos/${slug}`,
  resources: '/recursos',
  resourceGuiaTerapia: '/recursos/guia-terapia',
  resourcePreguntasFrecuentes: '/recursos/preguntas-frecuentes',
  resourcePrepararSesion: '/recursos/preparate',
  resourceCuidadoEnergetico: '/recursos/cuidado-energetico',
  resourceArteSanacion: '/recursos/arte-sanacion',
  resourceInspiracionAlma: '/recursos/inspiracion-alma',
  contact: '/contacto',
  // Auth
  login: '/auth/login',
  register: '/auth/register',
  recover: '/auth/recover',
  reset: '/auth/reset',
  // Cuenta
  account: '/cuenta',
  accountAppointments: '/cuenta/citas',
  accountOrders: '/cuenta/pedidos',
  accountFavorites: '/cuenta/favoritos',
  accountMessages: '/cuenta/mensajes',
  accountSettings: '/cuenta/configuracion',
  accountCart: '/cuenta/carrito',
  // Admin
  admin: '/admin',
  adminBookings: '/admin/agendamiento',
  adminEmails: '/admin/correos',
  adminGallery: '/admin/galeria',
  adminEvents: '/admin/eventos',
  adminAudios: '/admin/audios',
  adminContent: '/admin/contenido',
  adminSettings: '/admin/configuracion',
  adminCatalogs: '/admin/catalogos',
  adminResources: '/admin/recursos',
  adminUsers: '/admin/usuarios',
  adminReports: '/admin/reportes',
  adminTestimonials: '/admin/testimonios',
  // Admin — editores dedicados (refactor backoffice, reemplazan modales).
  adminEventNew: '/admin/eventos/nuevo',
  adminEventEdit: (id: string) => `/admin/eventos/${id}/editar`,
  adminGalleryNew: '/admin/galeria/nueva',
  adminGalleryEdit: (id: string) => `/admin/galeria/${id}/editar`,
  adminEmailTemplateEdit: (slug: string) => `/admin/correos/plantillas/${slug}/editar`,
  adminResourceNew: '/admin/recursos/nuevo',
  adminResourceEdit: (id: string) => `/admin/recursos/${id}/editar`,
  // Admin > Catálogos — editores dedicados (Turno 2).
  adminCatalogTherapyNew: '/admin/catalogos/terapias/nueva',
  adminCatalogTherapyEdit: (id: string) => `/admin/catalogos/terapias/${id}/editar`,
  adminCatalogProductNew: '/admin/catalogos/productos/nuevo',
  adminCatalogProductEdit: (id: string) => `/admin/catalogos/productos/${id}/editar`,
  adminCatalogTestimonialNew: '/admin/catalogos/testimonios/nuevo',
  adminCatalogTestimonialEdit: (id: string) => `/admin/catalogos/testimonios/${id}/editar`,
  // Pagos
  paymentResult: (ref: string) => `/pago/resultado?ref=${ref}`,
  // Legal
  privacy: '/legal/privacidad',
  terms: '/legal/terminos',
  cookies: '/legal/cookies',
} as const;

/** Nombres válidos de rutas (claves de `Routes`). */
export type RouteName = keyof typeof Routes;
